export { ShopTheRoomWidgetRenderer } from './ShopTheRoomWidgetRenderer'
